module.exports = __webpack_public_path__ + "img/16581290_S.63198caa.png";